import * as React from 'react';
import { LoaderProps } from '../../components/loader';

const LoaderView: React.StatelessComponent<LoaderProps> = props => {
    return (
        <div className="ace-loader" role="presentation">
            {
                //props.isProcessing ?
                //    <p>
                //        {props.text.performanceProcessingMessage}
                //    </p>
                //    : null
            }
            <div className="ace-loader-spinner">
                <div></div><div></div><div></div><div></div>
            </div>
        </div>
    )
}

export default LoaderView;